module.exports = __webpack_public_path__ + "resources/img/rule-img.80ac5d8b.png";